import { ImageIcon } from "lucide-react";

interface EmptyRecordsStateProps {
  projectName?: string;
  canUpload?: boolean;
}

export function EmptyRecordsState({
  projectName,
  canUpload,
}: EmptyRecordsStateProps) {
  const displayName = projectName ?? "this project";

  return (
    <div className="flex h-full w-full items-center justify-center px-10 py-12">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-muted">
          <ImageIcon className="h-12 w-12 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">No photos yet</h3>
          <p className="text-sm text-muted-foreground">
            {canUpload
              ? `Start adding photos to ${displayName} by tapping the button below.`
              : `Photos will appear here once they're added to ${displayName}.`}
          </p>
        </div>
      </div>
    </div>
  );
}
